
import ContactForm from "../component/contact-form.vue";
import HomeSlider from "../component/home-slider.vue";
import ThumbLinks from "../component/thumb-links.vue";
import BannerLink from "../component/banner-link.vue";
import SquareIndex from "../component/square-index.vue";
import TabbedIndex from "../component/tabbed-index.vue";
import HeaderVisual from "../component/header-visual.vue";
import TopicsPager from "../component/topics-pager.vue";
import GoogleMap from "../component/google-map.vue";

const components = {
  "contact-form": ContactForm,
  "home-slider": HomeSlider,
  "thumb-links": ThumbLinks,
  "banner-link": BannerLink,
  "square-index": SquareIndex,
  "tabbed-index": TabbedIndex,
  "header-visual": HeaderVisual,
  "topics-pager": TopicsPager,
  "google-map": GoogleMap,
};

class View {

  constructor (){
    this.els = document.querySelectorAll("[data-view]");

    Array.from(this.els).map((el) => {
      let name = el.getAttribute("data-view");
      let slot = el.innerHTML;
      let modifier = el.getAttribute("data-modifier") || "";

      if(name in components) {
        new Vue({
          el,
          components,
          template: `<${name} modifier="${modifier}">${slot}</${name}>`
        });
      } else {
        console.error(`invalid component name: ${name}`);
      }
    });
  }

}

export default new View();



// WEBPACK FOOTER //
// ./src/lib/view.js